  class HorizontalTabs extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = this.querySelectorAll(".tab-button");
      this.contentSections = this.querySelectorAll(".content-section");
      this.icons = this.querySelectorAll(".tabcontent-icon");
      this.tabsContainer = this.querySelector(".tab-buttons");
      this.tabWrapper = this.querySelector(".tab-btn-wrapper");
      this.prevBtn = this.querySelector(".tab-nav-prev");
      this.nextBtn = this.querySelector(".tab-nav-next");
  
      this.scrollAmount = 0;
  
      this.checkOverflow();
  
      this.nextBtn.addEventListener("click", () => this.scrollTabs(100));
      this.prevBtn.addEventListener("click", () => this.scrollTabs(-100));

      this.addEventListener("click", (event) => this.handleTabClick(event));
  
      this.dispatchEvent(new CustomEvent("horizontal-tabs-updated"));
    }
  
    checkOverflow() {
      const maxScroll =
        this.tabsContainer.scrollWidth - this.tabWrapper.clientWidth;
  
      this.prevBtn.disabled = this.scrollAmount === 0;
      this.nextBtn.disabled = this.scrollAmount >= maxScroll;
  
      if (this.tabsContainer.scrollWidth > this.tabWrapper.clientWidth) {
        this.nextBtn.style.display = "block";
        this.prevBtn.style.display = "block";
      } else {
        this.nextBtn.style.display = "none";
        this.prevBtn.style.display = "none";
      }
    }
  
    scrollTabs(delta) {
      const maxScroll =
        this.tabsContainer.scrollWidth - this.tabWrapper.clientWidth;
      this.scrollAmount += delta;
  
      if (this.scrollAmount > maxScroll) {
        this.scrollAmount = maxScroll;
      } else if (this.scrollAmount < 0) {
        this.scrollAmount = 0;
      }
  
      this.tabsContainer.style.transform = `translateX(-${this.scrollAmount}px)`;
      this.checkOverflow();
    }
  
    handleTabClick(event) {
      const target = event.target;
  
      if (
        target.classList.contains("tab-button") ||
        target.closest(".tab-button")
      ) {
        const clickedButton = target.closest(".tab-button");
        const targetId = clickedButton.getAttribute("data-target");
  
        this.tabButtons.forEach((btn) => btn.classList.remove("active"));
        this.contentSections.forEach((section) =>
          section.classList.remove("active")
        );
        
        this.icons.forEach((icon) => icon.classList.remove("active"));
  
        clickedButton.classList.add("active");
        document.getElementById(targetId).classList.add("active");
        this.querySelector(`.tabcontent-icon[data-target="${targetId}"]`).classList.add(
          "active"
        );
      }
    }
  }
  
  customElements.define("horizontal-tabs", HorizontalTabs);
  